import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Pagination, Stack } from "@mui/material";
import UserManagmentInfoCard from "./UserManagmentInfoCard";
import ModalLimitCheck from "./ModalLimitCheck";

// Styles
import styles from "./../UserManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const UserManagmentInfo = () => {
  const { userToken } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);
  const [modalLimitShow, setModalLimitShow] = useState(false);

  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const [userManagmentInfoData, setUserManagmentInfoData] = useState([]);

  const [limitedItem, setLimitedItem] = useState([
    { id: 1, name: "تعداد بازدید", status: false },
    { id: 2, name: "قیمت کل", status: false },
    { id: 3, name: "قیمت هر متر", status: false },
    { id: 4, name: "دسته‌بندی", status: false },
    { id: 5, name: "نوع فایل", status: false },
    { id: 6, name: "سایر امکانات", status: false },
    { id: 7, name: "اطلاعات خصوصی فایل", status: false },
    { id: 8, name: "توضیحات", status: false },
    { id: 9, name: "مشاوران فایل", status: false },
    { id: 10, name: "تعداد اتاق", status: false },
    { id: 11, name: "متراژ", status: false },
    { id: 12, name: "طبقه", status: false },
    { id: 13, name: "منطقه", status: false },
    // { id: 14, name: "نقشه", status: false },
    { id: 15, name: "نمودار تغییر قیمت", status: false },
    { id: 16, name: "سال ساخت", status: false },
    { id: 17, name: "آدرس کامل", status: false },
    // { id: 18, name: "درصد پورسانت و کمیسیون", status: false },
    { id: 19, name: "امکان حذف فایل", status: false },
  ]);

  function statusHandler(id) {
    const itemSelected = limitedItem.find(item => id === item.id);
    const newState = limitedItem.map(obj => {
      if (obj.id === id) {
        return { ...obj, status: !itemSelected.status };
      }
      return obj;
    });

    setLimitedItem(newState);
  }

  useMemo(() => userManagmentInfoData, [userManagmentInfoData]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getUsers = await axios.get("Users", {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getUsers.data.data.pageCount };
      });
      const users = getUsers.data.data.data;
      setUserManagmentInfoData(users);
      // console.log(users)

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      {/* <ModalLimitCheck
                show={modalLimitShow}
                onHide={() => setModalLimitShow(false)}
                limitedItem={limitedItem}
                statusHandler={statusHandler}
            /> */}

      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>اطلاعات و سوابق کاربران</div>
                  </div>

                  {/* <div className='d-flex align-items-center justify-content-end flex-wrap mt-2 mb-2' role="button" onClick={() => setModalLimitShow(true)}>
                                            <div className={styles.link_icon_text}>
                                                محدود سازی فایل
                                            </div>
                                            <img className='me-2 pe-1' src={arrowBlue} alt="arrow-blue-icon" />
                                        </div> */}
                </div>

                {/* User Managment Card */}
                <UserManagmentInfoCard userManagmentInfoData={userManagmentInfoData} setUserManagmentInfoData={setUserManagmentInfoData} />

                <Stack
                  className={Dstyles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu manageUsers manageUsersInfo />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getApiData = await axios.get(`Users?PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    setPage(prev => {
      return { ...prev, pageCount: getApiData.data.data.pageCount, pageNumber: value };
    });
    const users = getApiData.data.data.data;
    setUserManagmentInfoData(users);
    setIsLoading(false);
  }
};

export default UserManagmentInfo;
